import { render, staticRenderFns } from "./curve-dialog.vue?vue&type=template&id=223e1c59&scoped=true&"
import script from "./curve-dialog.vue?vue&type=script&lang=ts&"
export * from "./curve-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./curve-dialog.vue?vue&type=style&index=0&id=223e1c59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223e1c59",
  null
  
)

export default component.exports